﻿import { environment } from './../../../environments/environment';
import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from '../../_services';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';


@Component(
  {
    templateUrl: 'login.component.html', styleUrls: ['./login.component.scss']
  }
  )
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  err: HttpErrorResponse;
  demo: any;
  session: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/']);
    }
    this.demo = environment.DEMO;
    //this.session = this.document.location.hostname;
    // console.log(this.document.location.hostname);

  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.spinner.show();
    this.loading = true;
    this.authenticationService.login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(
        data => {
            if(data.status ==200){
                this.router.navigate([this.returnUrl]);
            }else{
               this.loading = false;
               this.spinner.hide();
               this.toastr.error(
                 "ยูสเซอร์เนม กับพาสเวิรด์ ไม่ถูกต้อง",
                 "เกิดข้อผิดพลาด",
                 { timeOut: 10000, closeButton: true }
               );
            }
        }
        ,
        error => {
          this.loading = false;
          this.spinner.hide();
          this.err = error;
          if (this.err.status === 0) {
            this.toastr.error('ติดต่อผู้ดูแลระบบ - error code : 100', 'เกิดข้อผิดพลาด', { timeOut: 10000, closeButton: true });
          }
          if (this.err.status === 500) {
            this.toastr.error('เกิดข้อผิดพลาด ติดต่อเจ้าหน้าที่', 'เกิดข้อผิดพลาด', { timeOut: 10000, closeButton: true });
          }
          if (this.err.status === 401 || this.err.status === 400) {
            this.toastr.error('ยูสเซอร์เนม กับพาสเวิรด์ ไม่ถูกต้อง', 'เกิดข้อผิดพลาด', { timeOut: 10000, closeButton: true });
          }
        }
        );
  }
}
